import React, { Component } from "react";
import Panel from "../../components/panel/Panel";
import PropTypes from "prop-types";
import { appConfig } from "../../config/appConfig";

class AddCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      cattype: "None",
    };
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(e) {
    this.setState({ cattype: e.target.value });
  }

  static propTypes = {
    actions: PropTypes.shape({
      addCategory: PropTypes.func,
    }),
  };
  handlesOnNameChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      // should add some validator before setState in real use cases
      this.setState({ name: event.target.value.trim() });
    }
  };

  handlesOnCatTypeChange = (event: SyntheticEvent<>) => {
    this.setState({ cattype: event.target.value });
  };

  handlesOnCatChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ cat: event.target.value });
    }
  };

  handlesOntypeChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ type: event.target.value });
    }
  };
  handlesOnstatusChange = (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
      this.setState({ status: event.target.value });
    }
  };

  handlesOnClick = async (event: SyntheticEvent<>) => {
    if (event) {
      event.preventDefault();
    }
    const { history } = this.props;
    const { name, cattype, cat, type, status } = this.state;

    const category = {
      name: name,
      cattype: cattype,
      cat: cat,
      type: type,
      status: status,
    };

    try {
      const {
        actions: { addCategory },
      } = this.props;
      addCategory(category);

      history.push({ pathname: "/categories" }); // back to Home
    } catch (error) {
      /* eslint-disable no-console */
      //console.log("login went wrong..., error: ", error);
      /* eslint-enable no-console */
    }
  };

  render() {
    const headerTitle = "Create a Category";
    const categoryType = [
      { value: "local", label: "local" },
      { value: "shopping", label: "Shopping" },
      { value: "parentcategory ", label: "ParentCategory" },
    ];
    const { selectedOption } = this.state;
    return (
      <div>
        <Panel hasTitle={true} title={headerTitle}>
          <form role="form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                className="form-control"
                id="catName"
                placeholder="Enter name"
                value={this.state.name}
                onChange={this.handlesOnNameChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="permalink">Permalink</label>
              <input
                type="text"
                className="form-control"
                id="permalink"
                placeholder="Enter permalink"
              />
            </div>

            <div className="form-group">
              <label htmlFor="cattype">Category Type: </label>
              <select
                name="cattype"
                value={this.state.cattype}
                className="form-control"
                onChange={this.handleChange.bind(this)}
              >
                <option value="None">None</option>
                <option value="local">Local</option>
                <option value="shopping">Shopping</option>
                <option value="parentcategory">Parent Category</option>
              </select>
            </div>

            <div className="form-group">
              <label>
                Category:
                <select
                  value={this.state.value}
                  className="form-control"
                  onChange={this.handlesOnCatChange}
                >
                  <option value="privateVip">Private VIP</option>
                </select>
              </label>
            </div>
            <div className="form-group">
              <label>
                Type:
                <select
                  value={this.state.value}
                  className="form-control"
                  onChange={this.handlesOntypeChange}
                >
                  <option value="category">Category</option>
                  <option value="subCategory">Sub Category</option>
                </select>
              </label>
            </div>
            <div className="form-group">
              <label>
                Active:
                <select
                  value={this.state.value}
                  className="form-control"
                  onChange={this.handlesOnstatusChange}
                >
                  <option value="active">Yes</option>
                  <option value="inactive">No</option>
                </select>
              </label>
            </div>
            <button
              type="submit"
              className="btn btn-info"
              onClick={this.handlesOnClick}
            >
              Save Category
            </button>
          </form>
        </Panel>
      </div>
    );
  }
}
export default AddCategory;



// WEBPACK FOOTER //
// ./src/app/views/addCategory/AddCategory.js